import CrowdfundingPropertiesAPI from './CrowdfundingPropertiesAPI';
export default CrowdfundingPropertiesAPI;
